import { Controller } from "@hotwired/stimulus";
import { useTransition } from "stimulus-use";

export default class extends Controller {
  static targets = ["menu", "input"];
  static values = {
    name: String,
  };

  connect() {
    useTransition(this, { element: this.menuTarget });
  }

  get toggled() {
    return this.element.classList.contains("toggled");
  }

  get empty() {
    return this.menuTarget.querySelector(':scope > [data-value="__empty"]');
  }

  get selectedItem() {
    return this.menuTarget.querySelector(":scope > .selected");
  }

  get firstVisibleItem() {
    return this.menuTarget.querySelector(":scope > :not(.hidden)");
  }

  onInput(event) {
    const { children } = this.menuTarget;
    const {
      target: { value },
    } = event;
    this.show();

    if (value === "") {
      this.resetChildren();
    } else {
      for (const node of children) {
        node.classList.remove("selected");

        if (node.dataset.value.toLowerCase().startsWith(value.toLowerCase())) {
          node.classList.remove("hidden");
        } else {
          node.classList.add("hidden");
        }
      }

      // select the first item
      let toSelect;
      if ((toSelect = this.firstVisibleItem)) {
        toSelect.classList.add("selected");
      }
    }
  }

  selected() {
    this.selectedEl(this.selectedItem);
  }

  selectedEl(el) {
    const value = el.dataset.value;
    const dispatchValue = value;
    this.currentValue = this.inputTarget.value =
      value === "__empty" ? "" : value;
    this.hide();
    this.resetChildren();
    this.dispatch("update", {
      detail: {
        name: this.nameValue,
        value: dispatchValue,
      },
    });
  }

  onKey(event) {
    switch (event.key) {
      case "Enter":
        this.selected();
        break;
      case "Escape":
        event.target.value = this.currentValue;
        if (this.transitioned) {
          this.hide();
          this.resetChildren();
        } else {
          event.target.blur();
        }
        break;
      case "ArrowUp":
        event.preventDefault();
        if (!this.transitioned) {
          this.show();
        } else {
          this.selectPrev();
        }
        break;
      case "ArrowDown":
        event.preventDefault();
        if (!this.transitioned) {
          this.show();
        } else {
          this.selectNext();
        }
        break;
    }
  }

  blur() {
    this.inputTarget.value = this.currentValue;
    this.hide();
    setTimeout(() => {
      this.resetChildren();
    }, 100);
  }

  chevronToggle(event) {
    event.preventDefault();

    if (this.toggled) {
      this.blur();
    } else {
      this.focus();
    }
  }

  focus() {
    this.currentValue = this.inputTarget.value;
    const firstVisible = this.firstVisibleItem;
    if (!this.selectedItem && firstVisible) {
      firstVisible.classList.add("selected");
    }
    this.inputTarget.select();
    this.show();
  }

  resetChildren() {
    for (const node of this.menuTarget.children) {
      node.classList.remove("selected", "hidden");
      if (node.dataset.value === this.currentValue) {
        node.classList.add("selected");
      }
    }
  }

  itemSelect(evt) {
    this.selectedEl(evt.target);
  }

  selectPrev() {
    const selected = this.selectedItem;
    let prev;
    if ((prev = selected.previousElementSibling)) {
      selected.classList.remove("selected");
      prev.classList.add("selected");
    }
  }

  selectNext() {
    const selected = this.selectedItem;
    let next;
    if ((next = selected.nextElementSibling)) {
      selected.classList.remove("selected");
      next.classList.add("selected");
    }
  }

  toggle() {
    this.element.classList.toggle("toggled");
    this.toggleTransition();
  }

  show() {
    this.element.classList.add("toggled");
    this.enter();
  }

  hide() {
    this.element.classList.remove("toggled");
    this.leave();
  }
}
